import { createContext, useContext } from "react";
import { DateRange } from "../types/common";

// La API rechaza con 400 los rangos de más de 180 días contando el primero y el último: entre los dos van 179.
export const MAX_SPAN_DAYS = 179;

export const ShowRangeContext = createContext<(range: DateRange) => void>(() => undefined);

export const useShowRange = () => useContext(ShowRangeContext);
